import React, { useEffect, useState } from "react";
import { fetchProducts } from "../api";
import SEO from './SEO';
import "bootstrap/dist/css/bootstrap.min.css";

const Services = ({ currentLanguage }) => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);

  const translations = {
    EN: {
      title: "Our Services",
      subtitle: "For over 10 years, clients have trusted Gators Transportation",
    },
    AR: {
      title: "خدماتنا",
      subtitle: "لمدة تزيد عن 10 سنوات، وثق العملاء في خدمات جاتورز للنقل",
    },
    ES: {
      title: "Nuestros Servicios",
      subtitle:
        "Durante más de 10 años, los clientes han confiado en Gators Transportation",
    },
  };

  useEffect(() => {
    fetchProducts()
      .then((response) => {
        setProducts(response.data);
        filterProducts(response.data, currentLanguage);
      })
      .catch((error) => console.error(error));
  }, [currentLanguage]);

  const filterProducts = (products, language) => {
    const filtered = products.map((product) => {
      const name =
        language === "AR"
          ? product.products_name_ar
          : language === "ES"
          ? product.products_name_es
          : product.products_name;

      const description =
        language === "AR"
          ? product.products_description_ar
          : language === "ES"
          ? product.products_description_es
          : product.products_description;

      const imagePathName = product.products_name || "";

      return {
        ...product,
        products_name: name,
        products_description: description,
        imagePathName,
      };
    });
    setFilteredProducts(filtered);
  };

  return (
    <>
      <SEO 
        title="Our Services | Disney World Universal SeaWorld Transfers"
        description="Professional transportation services to Disney World, Universal Studios, SeaWorld, Orlando International Airport (MCO), and Kissimmee Executive Airport. Theme park transfers and tourist transportation."
        keywords="Orlando tourism transportation, Disney World transportation, Universal Studios shuttle, SeaWorld Orlando transport, theme park transfers, MCO airport shuttle, tourist transportation Orlando, Disney resort shuttle, Orlando attractions transportation"
        canonical="/services"
      />
      <section className="py-5" style={{background:'#f8f9fa', width:'100vw', margin:0, padding:0, overflowX:'hidden'}}>
        <div className="container-fluid">
          <div className="text-center mb-5">
            <h1 className="mb-3">{translations[currentLanguage].title}</h1>
            <h5 className="text-muted">{translations[currentLanguage].subtitle}</h5>
          </div>
          
          <div className="row g-4 justify-content-center">
            {filteredProducts.map((product) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={product.products_id}>
                <div className="card shadow-lg border-0 h-100" style={{borderRadius:'1.5rem', background:'#fff', boxShadow:'0 8px 32px 0 rgba(31,38,135,0.12)'}}>
                  <div style={{borderRadius:'1.5rem 1.5rem 0 0', overflow:'hidden', height:'250px'}}>
                    <img
                      src={`/images/${product.imagePathName
                        .toLowerCase()
                        .replace(/\s+/g, "_")}.avif`}
                      className="card-img-top"
                      alt={product.products_name}
                      style={{width:'100%', height:'100%', objectFit:'cover'}}
                    />
                  </div>
                  <div className="card-body text-center p-4">
                    <h5 className="card-title mb-3" style={{color:'#2c3e50', fontWeight:'600'}}>{product.products_name}</h5>
                    <p className="card-text text-muted">{product.products_description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
